import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import { AuthProvider } from "./utils/AuthContext.js";
import { ThemeProvider } from "@mui/material";
import { Theme } from "./styles/Theme.js";
import { SnackbarProvider, Snackbar } from "src/utils/SnackbarContext.js";
import { ErrorBoundary, ErrorComponent } from "./utils/ErrorBoundary/index.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <ErrorBoundary fallback={<ErrorComponent />}>
        <SnackbarProvider>
          <AuthProvider>
            <Snackbar />
            <App />
          </AuthProvider>
        </SnackbarProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>
);
